import { Injectable, Injector } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { Inject, Optional } from '@angular/core';
import { DateLocaleService } from '../services/date-locale.service';
import * as moment from 'moment';

@Injectable()
export class DynamicMomentDateAdapter extends MomentDateAdapter {
  private dateLocaleService: DateLocaleService | null = null;

  constructor(
    @Optional() @Inject(MAT_DATE_LOCALE) dateLocale: string,
    private injector: Injector
  ) {
    super();

    // Try to get the service immediately
    try {
      this.dateLocaleService = this.injector.get(DateLocaleService);
    } catch {
      // Service not available yet, will try again later
      setTimeout(() => {
        try {
          this.dateLocaleService = this.injector.get(DateLocaleService);
        } catch (e) {
          console.warn('DateLocaleService not available:', e);
        }
      }, 100);
    }
  }

  override getFirstDayOfWeek(): number {
    if (this.dateLocaleService) {
      return this.dateLocaleService.getFirstDayOfWeek();
    }
    return 1; // Default to Monday
  }

  override format(date: moment.Moment, displayFormat: string): string {
    // Moment locale should already be set by the service
    return super.format(date, displayFormat);
  }
}